{
  "errors": {
    "network": "Erreur réseau. Veuillez vérifier votre connexion et réessayer.",
    "unknown": "Une erreur est survenue. Veuillez réessayer.",
    "operationNotSupported": "L'opération '{{operation}}' n'est pas prise en charge",
    "http": {
      "400": "Requête invalide",
      "401": "Non autorisé. Veuillez vous reconnecter.",
      "403": "Accès refusé",
      "404": "Non trouvé",
      "409": "Cet élément existe déjà",
      "422": "Échec de la validation. Veuillez vérifier vos saisies.",
      "500": "Erreur serveur. Veuillez réessayer plus tard.",
      "503": "Service temporairement indisponible"
    },
    "validation": {
      "required": "Ce champ est requis",
      "invalid": "Valeur invalide",
      "minLength": "Trop court",
      "maxLength": "Trop long",
      "duplicate": "Existe déjà",
      "email": "Adresse e-mail invalide",
      "password": "Le mot de passe ne répond pas aux exigences",
      "passwordsMismatch": "Les mots de passe ne correspondent pas",
      "failed": "Échec de la validation",
      "selectPerson": "Veuillez sélectionner une personne",
      "selectOrgFunction": "Veuillez sélectionner une fonction",
      "selectSystem": "Veuillez sélectionner un système",
      "selectExternalContact": "Veuillez sélectionner un contact externe",
      "fileRequired": "Veuillez choisir un fichier",
      "url": "URL invalide"
    },
    "department": {
      "duplicateAbbreviation": "Un département avec l'abréviation '{{abbreviation}}' existe déjà",
      "abbreviationAlreadyInUse": "L'abréviation de département '{{abbreviation}}' est déjà utilisée",
      "abbreviationDuplicateInData": "Abréviation en double '{{abbreviation}}' trouvée dans les données",
      "nameAlreadyInUse": "Le nom de département '{{name}}' est déjà utilisé",
      "nameDuplicateInData": "Nom en double '{{name}}' trouvé dans les données",
      "notFound": "Département non trouvé",
      "parentNotFound": "Département parent non trouvé",
      "selfParent": "Un département ne peut pas être son propre parent",
      "circularDependency": "Impossible de déplacer un département sous l'un de ses propres descendants",
      "hasSubdepartments": "Impossible de supprimer un département avec des sous-départements",
      "hasMembers": "Impossible de supprimer un département avec des personnes",
      "noManager": "Les départements suivants n'ont pas de responsable assigné : {{departments}}. Veuillez assigner des responsables avant de créer des processus.",
      "alreadyResolved": "Ce département a déjà un responsable attribué"
    },
    "orgFunction": {
      "notFound": "Fonction non trouvée",
      "mainRoleInvalidKind": "Le poste doit être une fonction de type poste",
      "nameDuplicateInData": "Nom en double « {{name}} » trouvé dans les données",
      "nameAmbiguous": "« {{name}} » est ambigu – une fonction et une équipe portent ce nom",
      "alreadyExists": "« {{name}} » existe déjà et a été ignoré"
    },
    "common": {
      "invalidId": "Identifiant invalide fourni"
    },
    "auth": {
      "invalidPassword": "E-mail ou mot de passe invalide. Veuillez réessayer.",
      "passwordUnchanged": "Votre nouveau mot de passe doit être différent de votre mot de passe actuel.",
      "userNotFound": "E-mail ou mot de passe invalide. Veuillez réessayer.",
      "unauthorized": "Non autorisé. Veuillez vous reconnecter.",
      "noMembership": "Vous n'avez pas encore accès à un espace de travail. Demandez une invitation à votre administrateur.",
      "ssoRequired": "Cet espace de travail requiert l'authentification unique (SSO). Continuez avec votre e-mail pour vous connecter via votre organisation.",
      "notZitadelLinked": "Votre compte n'est pas encore lié au système d'identité. Connectez-vous une fois via l'authentification unique ou contactez votre administrateur.",
      "reauthRequired": "Pour des raisons de sécurité, veuillez vous reconnecter avant de modifier vos paramètres de connexion."
    },
    "sso": {
      "stateExpired": "Votre session de connexion a expiré. Veuillez réessayer.",
      "exchangeFailed": "La connexion n'a pas pu être finalisée. Veuillez réessayer.",
      "transactionInvalid": "Cette connexion ne peut être finalisée que dans le navigateur où vous l'avez démarrée. Veuillez vous reconnecter.",
      "emailMismatch": "Le compte connecté ne correspond pas à l'e-mail saisi. Veuillez réessayer.",
      "emailUnverified": "Votre adresse e-mail n'est pas vérifiée. Veuillez la vérifier auprès de votre fournisseur d'identité, puis réessayer."
    },
    "user": {
      "notFound": "Utilisateur non trouvé",
      "alreadyExists": "Un compte avec cette adresse e-mail ({{email}}) existe déjà.",
      "duplicateEmail": "Un utilisateur avec l'e-mail '{{email}}' existe déjà dans cette organisation",
      "emailDuplicateInData": "Adresse e-mail en double '{{email}}' trouvée dans les données",
      "invalidEmail": "Adresse e-mail invalide",
      "inactive": "Le compte utilisateur est inactif",
      "suspended": "Votre compte a été suspendu. Veuillez contacter votre administrateur pour obtenir de l'aide.",
      "alreadySuspended": "Le compte utilisateur est déjà suspendu",
      "alreadyActive": "Le compte utilisateur est déjà actif",
      "invalidStatus": "Statut d'utilisateur invalide",
      "alreadyHasCredentials": "Cette personne dispose déjà d'identifiants de connexion et peut se connecter directement – aucun lien d'activation n'est nécessaire.",
      "emailChangeNotAllowed": "L'adresse e-mail de cette personne ne peut pas être modifiée car elle constitue son identité de connexion. Contactez le support si une modification est nécessaire.",
      "externalMemberNoDepartment": "Les personnes externes ne peuvent pas être assignées à un département",
      "externalMemberNoTeam": "Les personnes externes ne peuvent pas être assignées à une fonction",
      "externalMemberRequiresRole": "Les membres externes doivent recevoir au moins un type d'utilisateur",
      "userTypesTenantTypeMismatch": "Ces rôles n'existent pas pour ce type d'organisation. Les organisations partenaires attribuent les rôles partenaires, les organisations clientes et de démonstration les rôles clients.",
      "memberIsTeamLead": "Impossible de reclasser en externe : la personne est actuellement responsable de fonction. Retirez-la d'abord de son rôle de responsable de fonction.",
      "emailNotFound": "Aucun collaborateur trouvé avec l'e-mail « {{email}} »"
    },
    "partner": {
      "tenantRequired": "Cet espace est réservé aux organisations partenaires.",
      "adminRequired": "Cette action est réservée aux admins partenaires.",
      "memberRequiresRole": "Un membre d'une organisation partenaire doit avoir un rôle partenaire.",
      "memberMustBeInternal": "Les membres d'une organisation partenaire sont les collaborateurs internes de la société partenaire.",
      "hubspotNotLinked": "Ce compte partenaire n'est encore lié à aucune entreprise HubSpot. Un administrateur Bliks doit établir ce lien.",
      "salesNotActivated": "Ce membre n'est pas activé pour les ventes ; le lead n'a donc aucun apporteur à qui être attribué. Un admin partenaire peut l'activer dans la gestion des utilisateurs.",
      "salesAlreadyActivated": "Ce membre est déjà activé pour les ventes.",
      "memberNotActive": "Ce membre n'a pas encore accepté son invitation. L'activation pour la vente ne sera possible qu'après sa première connexion.",
      "contactAlreadyLinked": "Ce contact HubSpot est déjà lié à un autre membre.",
      "memberNoEmail": "Une adresse e-mail est requise pour lier un membre à un contact HubSpot.",
      "contactNotAdoptable": "Ce contact HubSpot appartient à une autre entreprise partenaire et ne peut pas être ajouté ici.",
      "materialNotFound": "Ce support n'existe plus.",
      "materialFileNotFound": "Aucun fichier n'est disponible pour ce support.",
      "materialUploadInvalid": "Le téléversement n’est pas valide. Veuillez téléverser à nouveau le fichier.",
      "newsNotFound": "Cette actualité n’existe plus.",
      "newsImageInvalid": "L’image n’est pas valide. Veuillez la téléverser à nouveau."
    },
    "role": {
      "selfRemovalForbidden": "Vous ne pouvez pas retirer votre propre rôle : vous perdriez l'accès nécessaire pour annuler ce changement. Demandez à un autre admin de le faire.",
      "lastHolderForbidden": "Il s'agit du dernier admin actif. Plus personne ne pourrait gérer les utilisateurs de cette organisation."
    },
    "recording": {
      "invalidStatusForAction": "Cette action n'est pas autorisée dans l'état actuel de l'enregistrement",
      "nameOrDescriptionRequired": "Un nom et une description sont requis pour finaliser l'enregistrement",
      "userNotRecordingStep": "Vous n'êtes pas en train d'enregistrer cette étape",
      "nudgeTargetNotActive": "Cette personne ne peut pas recevoir de rappels, car son compte n'est pas actif",
      "decisionRuleNotFound": "Règle de décision non trouvée",
      "decisionHasNoRules": "La décision n'a aucune règle définie"
    },
    "process": {
      "notFound": "Processus non trouvé",
      "duplicateName": "Un processus avec le nom '{{name}}' existe déjà",
      "invalidOperation": "Cette opération n'est pas autorisée dans l'état actuel"
    },
    "processEvent": {
      "notFound": "Événement introuvable",
      "startRequired": "Un processus a besoin d'un événement de départ — il ne peut pas être supprimé ni converti"
    },
    "processChain": {
      "notFound": "Chaîne de processus non trouvée",
      "circularDependency": "Impossible de créer une dépendance circulaire entre les chaînes de processus",
      "selfParent": "Une chaîne de processus ne peut pas être son propre parent",
      "typeConflict": "Une chaîne ne peut pas contenir à la fois des sous-chaînes et des processus."
    },
    "processConnection": {
      "notFound": "Connexion de processus non trouvée"
    },
    "processStep": {
      "notFound": "Étape de processus non trouvée"
    },
    "processDraft": {
      "notFound": "Aucun brouillon n'existe pour ce processus.",
      "alreadyExists": "Un brouillon existe déjà pour ce processus.",
      "publishContentValidation": "Certaines étapes n'ont pas le contenu requis.",
      "publishGraphValidation": "Certaines étapes sont déconnectées ou orphelines.",
      "publishConflict": "Le processus publié a changé pendant votre édition.",
      "stepNotFound": "Étape du brouillon introuvable.",
      "edgeNotFound": "Cette connexion n'existe plus dans le brouillon.",
      "deleteFailed": "Impossible de supprimer cet élément — veuillez réessayer.",
      "deletePartialFailure": "Certaines étapes n'ont pas pu être supprimées — veuillez réessayer.",
      "deleteStaleSelection": "Ces étapes ont déjà été supprimées.",
      "noteNotFound": "Note non trouvée.",
      "historyNotFound": "Aucun historique de modification n'existe pour ce brouillon.",
      "insertNotApplicable": "Cette étape ne peut plus être insérée ici.",
      "eventInputNotLinkable": "Aucun événement ne peut être rattaché à cette entrée.",
      "convertRequiresPreviousOutput": "Une affectation nécessite au moins un résultat entrant."
    },
    "organization": {
      "notFound": "Organisation non trouvée"
    },
    "approval": {
      "notFound": "Validation introuvable",
      "notPending": "Cette validation n'est plus ouverte",
      "notReviewer": "Vous n'êtes pas désigné pour cette validation",
      "ownRequest": "Votre propre demande est validée par quelqu'un d'autre",
      "alreadyDecided": "Vous avez déjà décidé",
      "reasonRequired": "Veuillez indiquer un motif",
      "overrideNotAllowed": "La règle ne permet pas de continuer sans validation",
      "notRequester": "Seul le demandeur peut retirer la demande",
      "notAdmin": "Réservé aux administrateurs de l'espace de travail"
    },
    "task": {
      "notFound": "Tâche non trouvée",
      "alreadyCompleted": "La tâche n'est plus ouverte",
      "assigneeNotFound": "La personne pour cette tâche n'a pas été trouvée"
    },
    "assignment": {
      "notFound": "Attribution non trouvée",
      "alreadyCompleted": "Attribution déjà terminée",
      "alreadyAcceptedByTeammate": "Cette tâche a déjà été acceptée par un autre titulaire de cette fonction. Merci pour votre engagement.",
      "taskNotDefined": "La tâche d'attribution n'est pas encore définie",
      "rulesNotDefined": "Les règles d'attribution ne sont pas encore définies",
      "outputNotDefined": "La sortie de l'attribution est requise",
      "alreadyFinished": "Attribution déjà terminée",
      "reassigneeNotFound": "Cible de réassignation non trouvée",
      "notExternalContact": "Cette étape n'est pas attribuée à un contact externe",
      "recordingDelegateNotFound": "La personne sélectionnée est introuvable"
    },
    "merge": {
      "targetNotFound": "L'enregistrement de l'étape cible n'a pas été trouvé.",
      "targetNotCompleted": "L'enregistrement de l'étape cible n'est pas encore terminé.",
      "targetWrongProcess": "L'enregistrement de l'étape cible appartient à un autre processus.",
      "userNotRelated": "Vous n'avez aucune relation avec cet enregistrement d'étape.",
      "sameNode": "Une étape ne peut pas être fusionnée avec elle-même."
    },
    "system": {
      "notFound": "Système non trouvé",
      "nameDuplicateInData": "Nom de système en double « {{name}} » trouvé dans les données",
      "alreadyExists": "Le système « {{name}} » existe déjà et a été ignoré"
    },
    "artifact": {
      "notFound": "Document non trouvé"
    },
    "externalContact": {
      "notFound": "Contact externe non trouvé"
    },
    "tenant": {
      "notFound": "Locataire non trouvé",
      "expired": "L'accès de votre organisation a expiré. Veuillez contacter votre administrateur.",
      "cloneFailed": "Échec de la duplication du locataire. La copie incomplète peut subsister — vous pouvez l'abandonner depuis la liste des locataires.",
      "cloneDiscardRefused": "La suppression de la copie a été refusée par une vérification de sécurité, par exemple parce que la duplication s'est finalement terminée et que le locataire ne relève plus de cette tâche, ou parce que son traitement est toujours en cours. Rien n'a été supprimé.",
      "cloneInProgress": "Une duplication concernant ce locataire est toujours en cours. Veuillez attendre qu'elle se termine, puis réessayer. Une duplication en cours ne peut pas être annulée.",
      "slugAlreadyInUse": "Cet identifiant est déjà utilisé par un autre locataire. Veuillez en choisir un autre.",
      "typeChangeStrandsMembers": "Le type de cette organisation ne peut pas être modifié tant que {{count}} membres détiennent des rôles du type actuel. Ajustez d'abord ces rôles ou videz l'organisation.",
      "hubspotCompanyAlreadyLinked": "Cette entreprise HubSpot est déjà liée à un autre locataire."
    },
    "appConfig": {
      "notConfigurable": "Cette application n'a pas de paramètres configurables.",
      "invalid": "La configuration ne correspond pas à ce que l'application attend."
    },
    "seatLimit": {
      "systemAdminsReached": "La limite de sièges pour les administrateurs système est atteinte ({{current}} sièges occupés sur {{limit}}). Veuillez suspendre ou supprimer un administrateur système ou faire relever la limite.",
      "orgManagersReached": "La limite de sièges pour les responsables d'organisation est atteinte ({{current}} sièges occupés sur {{limit}}). Veuillez suspendre ou supprimer un responsable d'organisation ou faire relever la limite.",
      "membersReached": "La limite de sièges pour les utilisateurs de base est atteinte ({{current}} sièges occupés sur {{limit}}). Veuillez suspendre ou supprimer un utilisateur de base ou faire relever la limite.",
      "appSeatsReached": "Cette application dispose de {{limit}} sièges, mais {{requested}} utilisateurs ont été affectés. Veuillez affecter moins d'utilisateurs ou faire relever la limite.",
      "appSeatOrgManagerNotSeatable": "Les responsables d'organisation accèdent déjà à toutes les applications et ne peuvent pas occuper de siège. Veuillez les retirer de l'affectation, puis enregistrer de nouveau."
    },
    "seatOverrun": "Votre organisation compte plus d'utilisateurs que de sièges. Un responsable d'organisation ou un administrateur système doit suspendre ou supprimer un utilisateur avant que les modifications puissent être enregistrées.",
    "initialSetup": {
      "alreadyCompleted": "La configuration initiale a déjà été effectuée et ne peut pas être exécutée à nouveau.",
      "prerequisitesMissing": "Veuillez d'abord configurer les départements et les collaborateurs",
      "notCompleted": "La configuration initiale de votre organisation n'est pas encore terminée. Les modifications ne seront possibles qu'ensuite.",
      "updateNotAllowed": "Cette entrée ne peut plus être modifiée ici. Veuillez recharger la page et réessayer.",
      "removalBlocked": "Cette entrée ne peut pas être supprimée car d'autres entrées y font référence.",
      "incomplete": "La configuration initiale est incomplète. Veuillez corriger les lacunes restantes avant de finaliser."
    },
    "dataSync": {
      "syncRunNotFound": "Cette synchronisation n'existe plus.",
      "syncRunInProgress": "Une synchronisation est déjà en cours pour cette organisation. Veuillez réessayer une fois celle-ci terminée.",
      "syncRunStale": "Cette synchronisation s'est arrêtée avant la fin. Veuillez lancer une nouvelle synchronisation.",
      "syncRunNotInReview": "Cette synchronisation ne peut plus être appliquée. Veuillez lancer une nouvelle synchronisation.",
      "selectionInvalid": "Certaines modifications sélectionnées ne peuvent pas être appliquées telles quelles. Veuillez vérifier la sélection et réessayer.",
      "excelInvalidIds": "Le fichier contient des ID non valides ({{rows}}). Veuillez conserver telles quelles les ID du fichier téléchargé.",
      "excelDuplicateEmails": "Plusieurs lignes partagent une adresse e-mail ({{rows}}). Chaque personne doit avoir sa propre adresse e-mail.",
      "excelDuplicateIds": "Plusieurs lignes portent le même ID ({{rows}}). Veuillez télécharger le fichier actuel et y saisir vos modifications.",
      "excelUnknownIds": "Le fichier contient des ID qui n'existent pas dans Bliks ({{rows}}). Veuillez télécharger le fichier actuel et y saisir vos modifications.",
      "excelMismatchedIds": "Ces lignes portent le nom d'une autre entrée ({{rows}}). Veuillez télécharger le fichier actuel et y saisir vos modifications. Pour donner à une entrée le nom d'une entrée que ce fichier supprime, importez d'abord la suppression.",
      "excelDuplicateNames": "Plusieurs nouvelles lignes portent le même nom ({{rows}}). Veuillez donner un nom distinct à chaque nouvelle entrée.",
      "excelNameMatchesSeveral": "Ces lignes sans ID portent un nom que plusieurs entrées existantes ont ({{rows}}). Veuillez saisir l'ID de l'entrée visée, tel qu'il figure dans le fichier téléchargé.",
      "excelEmptyReferencedSheet": "La feuille {{sheet}} ne contient aucune ligne, mais d'autres lignes en nomment des entrées. Veuillez ajouter ces entrées à la feuille {{sheet}} ou vider les cellules qui les nomment.",
      "excelAmbiguousNames": "Plusieurs lignes portent un nom auquel une autre cellule fait référence ({{rows}}). Veuillez rendre les noms uniques.",
      "excelUnresolvedReferences": "Ces lignes nomment un département ou un poste absent du fichier ({{rows}}). Veuillez l'ajouter à la feuille {{departmentsSheet}} ou {{rolesSheet}}, ou corriger le nom.",
      "excelParentCycle": "Ces départements sont mutuellement parents l'un de l'autre ({{rows}}). Veuillez corriger les départements parents.",
      "excelUnknownEmails": "Ces lignes nomment une adresse e-mail qui n'appartient à personne ({{rows}}). Veuillez ajouter la personne à la feuille {{peopleSheet}} ou corriger l'adresse.",
      "excelUnlistedLeads": "Ces lignes nomment une personne que le fichier supprime ({{rows}}). Veuillez ajouter la personne à la feuille {{peopleSheet}} ou nommer une autre personne.",
      "excelNoPeople": "La feuille {{sheet}} ne contient aucune personne.",
      "personioNotLinked": "Personio n'est pas connecté.",
      "personioCredentialsRejected": "Personio a refusé les identifiants. Veuillez vérifier l'ID client et le secret client.",
      "personioReadFailed": "Personio n'a pas pu être lu entièrement. Rien n'a été modifié. Veuillez réessayer plus tard.",
      "personioCredentialsUnreadable": "Les identifiants Personio enregistrés ne peuvent plus être lus. Veuillez reconnecter Personio."
    },
    "capacity": {
      "manualNotApplicable": "Cette étape est attribuée à un système ou à un contact externe ; elle ne collecte donc aucune capacité."
    },
    "survey": {
      "notFound": "Enquête non trouvée",
      "notApplicable": "Cette enquête ne vous pose aucune question",
      "variantCheckNotApplicable": "Cette question ne vous est pas destinée",
      "variantDescriptionRequired": "Veuillez décrire ce que vous faites différemment",
      "variantVerdictRequired": "Veuillez d'abord indiquer si vous effectuez cette étape de la même manière",
      "variantAlreadyAnswered": "Cette enquête a déjà reçu une réponse. Veuillez recharger la page.",
      "alreadyDismissed": "Cette enquête a déjà été refusée"
    },
    "entitySuggestion": {
      "notFound": "Suggestion d'entité non trouvée",
      "invalidTransition": "Cette suggestion ne peut pas passer à cet état",
      "missingAdminField": "Un champ réservé aux administrateurs est requis"
    },
    "insufficientPermissions": "Autorisations insuffisantes",
    "totp": {
      "unavailable": "L'authentification à deux facteurs n'est pas disponible pour votre compte.",
      "invalidCode": "Le code est invalide. Veuillez réessayer.",
      "alreadyConfigured": "L'authentification à deux facteurs est déjà configurée. Supprimez-la d'abord pour la reconfigurer.",
      "registrationNotFound": "Aucune configuration 2FA en attente n'a été trouvée. Veuillez recommencer la configuration."
    },
    "passkeys": {
      "unavailable": "Les clés d'accès ne sont pas disponibles pour votre compte.",
      "lastAuthMethod": "Cette clé d'accès est votre dernière méthode de connexion et ne peut pas être supprimée. Veuillez d'abord configurer un mot de passe ou une autre clé d'accès."
    },
    "homeOrgMove": {
      "noIdentity": "Cet utilisateur n'a pas d'identité de connexion à déplacer.",
      "targetNotSsoEnabled": "L'organisation sélectionnée n'est pas compatible SSO.",
      "noMembershipInTarget": "Cet utilisateur n'est pas un membre actif de l'organisation sélectionnée.",
      "staffRefused": "Les comptes du personnel ne peuvent pas être déplacés vers une autre organisation d'origine.",
      "identityDisabled": "L’identité de connexion de cet utilisateur est désactivée et ne peut pas être déplacée.",
      "conflict": "L’identité de connexion de l’utilisateur a changé pendant le déplacement. Veuillez recharger la page et réessayer.",
      "emailConflict": "Un compte de connexion avec l’adresse e-mail {{email}} appartient déjà à une autre personne.",
      "deadEmailSyncItem": "Un élément de synchronisation de changement d’adresse e-mail est bloqué pour cette personne. Veuillez le relancer ou le supprimer dans la file de synchronisation avant de déplacer l’organisation d’origine."
    },
    "signInReset": {
      "notPermitted": "Seul un administrateur système de l’organisation d’origine de cette personne peut réinitialiser ses identifiants de connexion.",
      "self": "Vous ne pouvez pas réinitialiser vos propres identifiants de connexion.",
      "userNotActive": "Seuls les identifiants de connexion des membres actifs peuvent être réinitialisés. Pour une invitation en attente, renvoyez plutôt l’invitation.",
      "noHomeOrg": "L’organisation d’origine de cette personne est inconnue : ses identifiants de connexion ne peuvent pas être réinitialisés ici.",
      "homeOrgDeleted": "L’organisation d’origine de cette personne a été supprimée. Attribuez une nouvelle organisation d’origine avant de réinitialiser ses identifiants de connexion.",
      "ssoEnforced": "Cette personne se connecte via l’authentification unique (SSO) de son organisation : ses identifiants de connexion y sont gérés.",
      "conflict": "Les identifiants de connexion de cette personne ont changé pendant la réinitialisation. Veuillez recharger la page et réessayer.",
      "identityDisabled": "Les identifiants de connexion de cette personne sont désactivés et ne peuvent donc pas être réinitialisés. Veuillez d’abord rétablir son accès.",
      "emailChangeUnsettled": "Un changement d’adresse e-mail pour cette adresse n’a pas encore été appliqué aux identifiants de connexion de cette personne : ils ne peuvent pas être réinitialisés pour le moment. Veuillez réessayer dans quelques minutes ; si le problème persiste, contactez le support."
    },
    "stepTemplate": {
      "notFound": "Modèle d'étape introuvable",
      "invalidSelection": "La sélection contient des éléments qui n'appartiennent pas à ce brouillon",
      "corrupt": "Le modèle d'étape est corrompu et ne peut pas être inséré"
    },
    "app": {
      "notFoundInRegistry": "Cette application n'est pas disponible.",
      "notAvailableForTenant": "Cette application n'est pas disponible pour votre espace de travail. Veuillez contacter votre administrateur.",
      "notUnlocked": "Cette application n'est pas débloquée pour ce locataire.",
      "notInstalled": "Cette application n'est pas installée pour votre espace de travail.",
      "notActive": "Cette application n'est pas active pour votre espace de travail.",
      "fileNotFound": "Fichier non trouvé",
      "fileTypeUnsupported": "Type de fichier non pris en charge : {{mimeType}}",
      "fileTooLarge": "Le fichier dépasse la limite de {{maxSizeBytes}} octets.",
      "fileExpired": "Ce fichier n'est plus disponible : sa durée de conservation est écoulée."
    },
    "appChat": {
      "sessionNotFound": "Cette session de discussion n'existe plus."
    },
    "omniscient": {
      "exportNotFound": "Export non trouvé"
    },
    "transcription": {
      "audioFormatUnsupported": "Format audio non pris en charge : {{mimeType}}"
    },
    "chat": {
      "messageNotFound": "Ce message n'existe plus."
    },
    "account": {
      "parentCycle": "Ce compte ne peut pas dépendre de lui-même.",
      "parentTooDeep": "Le groupe est imbriqué trop profondément.",
      "companyAlreadyAssigned": "Cette entreprise HubSpot est déjà associée à un autre compte.",
      "partnerCompanyLocked": "Ce compte gère un espace de travail partenaire ({{tenantName}}). Seule une personne qui administre les espaces de travail peut modifier son entreprise HubSpot.",
      "notFound": "Compte introuvable."
    },
    "hubspot": {
      "companyNotFound": "Aucune entreprise HubSpot avec cet identifiant."
    },
    "superAdmin": {
      "lastAdmin": "Plus personne ne pourrait se connecter en tant qu'administration de la plateforme — et elle seule peut attribuer des rôles."
    }
  }
}
